// Assets mission 4 — 3. TEAM (design_handoff_assets README §4 Hooks: "a person's
// record lists their assets (read of assignedTo == uid). Onboarding's
// new-starter view gets a 'Kit' line; offboarding shows what to collect.
// Read-only here; reassigning is done on the asset.").
//
// The pure half (kitFor, kitLine, collectLines) lives in assets-hooks-model.js, re-exported
// here for views/team.js; loadKit is the one read. assignedTo is a users doc id,
// or its path ('users/{id}', SCHEMA-CHANGE.md) — both are matched.
import { canAssets } from '../assets-access.js';
import { collection, query, where, getDocs } from '../fb/firestore.js';
import { db } from '../firebase.js';
import { ORG_ID } from '../config.js';
import { hasFeature } from '../features.js';
import { kitFor, kitLine, collectLines } from '../assets-hooks-model.js';

export { kitFor, kitLine, collectLines };
const tail = (v) => String(v == null ? '' : v).split('/').pop();

/** The read: assets assigned to this person. [] when the company has no Assets, or the read is refused. */
export async function loadKit(userId) {
  if (!canAssets() || !userId) return [];
  const id = tail(userId);
  try {
    const snap = await getDocs(query(collection(db, `organisations/${ORG_ID}/assets`), where('assignedTo', 'in', [id, `users/${id}`])));
    return kitFor(snap.docs.map((d) => ({ id: d.id, ...d.data() })), id);
  } catch (e) {
    console.warn('[assets] kit read refused:', e && e.message);
    return [];
  }
}
